var map = {
	"./assessment-visualizador/assessment-visualizador.module": [
		"./src/app/modules/visualizador/assessment-visualizador/assessment-visualizador.module.ts",
		"common"
	],
	"./auth/recovery/recovery.module": [
		"./src/app/auth/recovery/recovery.module.ts",
		"recovery.module"
	],
	"./auth/register/register.module": [
		"./src/app/auth/register/register.module.ts",
		"register.module"
	],
	"./gestao-visualizador/gestao-visualizador.module": [
		"./src/app/modules/visualizador/gestao-visualizador/gestao-visualizador.module.ts",
		"common"
	],
	"./helpdesk/helpdesk.module": [
		"./src/app/settings/dashboard-client/lele/helpdesk/helpdesk.module.ts",
		"common",
		"helpdesk.module.0"
	],
	"./modules/visualizador/visualizador.module": [
		"./src/app/modules/visualizador/visualizador.module.ts",
		"common",
		"visualizador.module"
	],
	"./public/companies/companies.module": [
		"./src/app/public/companies/companies.module.ts",
		"companies.module"
	],
	"./public/educators/educators.module": [
		"./src/app/public/educators/educators.module.ts",
		"common",
		"educators.module"
	],
	"./public/helpdesk/helpdesk.module": [
		"./src/app/public/helpdesk/helpdesk.module.ts",
		"common",
		"helpdesk.module"
	],
	"./public/intro/intro.module": [
		"./src/app/public/intro/intro.module.ts",
		"intro.module"
	],
	"./public/producer/producer.module": [
		"./src/app/public/producer/producer.module.ts",
		"producer.module"
	],
	"./settings/dashboard-client/lele/lele.module": [
		"./src/app/settings/dashboard-client/lele/lele.module.ts",
		"lele.module",
		"common"
	],
	"./settings/dashboard-client/store/store.module": [
		"./src/app/settings/dashboard-client/store/store.module.ts",
		"store.module"
	],
	"./settings/dashboard-companies/dashboard-companies.module": [
		"./src/app/settings/dashboard-companies/dashboard-companies.module.ts",
		"common",
		"dashboard-companies.module"
	],
	"./settings/dashboard-educators/dashboard-educators.module": [
		"./src/app/settings/dashboard-educators/dashboard-educators.module.ts",
		"dashboard-educators.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main